"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.OpenButton = exports.Inner = exports.CloseButton = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _constants = require("./constants");
const Root = exports.Root = (0, _mui.styled)('div')({
  bottom: 0,
  left: 0,
  position: 'fixed',
  width: '100%',
  // Web messenger has z-index 100, so we need to set higher z-index for app promo banner.
  zIndex: 101
});
const Inner = exports.Inner = (0, _mui.styled)('a', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme
}) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.spacing(2),
  boxShadow: _mui.SHADOW_LEVEL3,
  color: theme.palette.text.primary,
  display: 'flex',
  gap: theme.spacing(2),
  height: _constants.APP_PROMO_BANNER_HEIGHT,
  margin: theme.spacing(2),
  paddingRight: theme.spacing(1),
  textDecoration: 'none',
  '&:hover, &:active': {
    boxShadow: _mui.SHADOW_LEVEL1,
    color: theme.palette.text.primary,
    transition: theme.transitions.create(['box-shadows'], {
      duration: theme.transitions.duration.short
    })
  }
}));
const CloseButton = exports.CloseButton = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  padding: theme.spacing(2, 0),
  width: theme.spacing(7)
}));
const OpenButton = exports.OpenButton = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginLeft: 'auto',
  padding: theme.spacing(3, 6)
}));
